import { useTranslation } from "react-i18next";
import type { PaymentRail } from "../../lib/kiosk-client";
import type { FlowState } from "../../pages/FlowPage";
import { BigButton } from "../BigButton";

interface Props {
  state: FlowState;
  methods: PaymentRail[];
  onNext: (update: Partial<FlowState>) => void;
}

export function MethodStep({ state, methods, onNext }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 p-8 h-full justify-center">
      <h2 className="text-3xl font-bold text-center">
        {t("flow.method.title")}
      </h2>
      <div className="flex flex-1 min-h-0 flex-col gap-4 overflow-y-auto">
        {methods.map((m) => (
          <BigButton
            key={m.feature_path}
            variant={
              state.feature_path === m.feature_path ? "primary" : "secondary"
            }
            fullWidth
            onClick={() => onNext({ feature_path: m.feature_path })}
          >
            {m.display_name}
          </BigButton>
        ))}
      </div>
    </div>
  );
}
